import React, { createContext, useContext, ReactNode } from 'react';

interface UserContextType {
  roles: string[];
  user: any; // Hier sollte der User-Type aus der API verwendet werden
}

const UserContext = createContext<UserContextType | undefined>(undefined);

interface UserProviderProps {
  children: ReactNode;
  roles: string[];
  user: any;
}

export const UserProvider: React.FC<UserProviderProps> = ({ children, roles, user }) => {
  return (
    <UserContext.Provider value={{ roles, user }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = (): UserContextType => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};

// Hook für einfachere Verwendung der Rollen
export const useUserRoles = (): string[] => {
  const { roles } = useUserContext();
  return roles;
};
